import { render, staticRenderFns } from "./ButtonTertiary.vue?vue&type=template&id=06c8eb8e&scoped=true"
import script from "./ButtonTertiary.vue?vue&type=script&lang=js"
export * from "./ButtonTertiary.vue?vue&type=script&lang=js"
import style0 from "./ButtonTertiary.vue?vue&type=style&index=0&id=06c8eb8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c8eb8e",
  null
  
)

export default component.exports